// import React from 'react';

export const formatPhone = (phone: string) => {
    if (!phone) return '';
    const newMobile = phone.replace(/^\+?64/, '0');
    return newMobile.replace(/(\d{3})(\d{3})(\d)/, '$1 $2 $3');
};